import './css/styles.scss';

function initFotter() {
	const footerNav = document.querySelector('[data-footer-nav]');
	if (!footerNav) return;

	const toggleBtns = footerNav.querySelectorAll('.toggle-button');
	if (!toggleBtns) return;

	toggleBtns.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			const target = e.currentTarget as HTMLElement;
			const parent = target.parentElement;
			if (!parent) return;

			const subMenu = parent.querySelector('.sub-menu');
			if (!subMenu) return;

			if (parent.classList.contains('active')) {
				// animate slide up submenu
				parent.classList.remove('active');

				subMenu.style.height = subMenu.clientHeight + 'px';
				setTimeout(() => {
					subMenu.style.height = '0px';
				}, 0);
				setTimeout(() => {
					subMenu.style.height = '';
				}, 300);

				subMenu.setAttribute('aria-expanded', 'false');
			} else {
				// close other submenus
				const activeSubMenus =
					footerNav.querySelectorAll('.sub-menu.active');

				activeSubMenus.forEach((subMenu) => {
					subMenu.classList.remove('active');
					subMenu.style.height = subMenu.clientHeight + 'px';
					setTimeout(() => {
						subMenu.style.height = '0px';
					}, 0);
					setTimeout(() => {
						subMenu.style.height = '';
					}, 300);
				});

				parent.classList.add('active');

				// animate slide down submenu
				subMenu.style.height = 'auto';
				const height = subMenu.clientHeight + 'px';
				subMenu.style.height = '0px';
				setTimeout(() => {
					subMenu.style.height = height;
				}, 0);

				subMenu.setAttribute('aria-expanded', 'true');
			}
		});
	});
}

// on document ready
document.addEventListener('DOMContentLoaded', () => {
	initFotter();
});
